<template lang="pug">
div
  FlowEditor(:flowAliases="aliases")
</template>

<script>
import FlowEditor from "@/components/FlowEditor";

export default {
  name: "company-profile-details",

  components: {
    FlowEditor,
  },

  // props: ["data"],

  data: () => ({
    aliases: ["company_free", "company_profile_paid"],
  }),
};
</script>